import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { getDateRangeData } from "../../store/actions/paymentActions";
import DateRange from "../dashboard/DateRange";
import DepositSlipComponent from "./DepositSlipComponent";
import { generatePdf } from "../../utils/generatePdf.js";
import { convertDateInFormat } from "../../utils/utils";
import logo from "../../Assets/logo/logo_2x.svg";
const DepositeSlip = () => {
  const [daterangeData, setDateRangeData] = useState({});
  const [showPdf, setShowPdf] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const userDetails = localStorage.getItem("userDetails");
  const userId = JSON.parse(userDetails).user.code;
  const branchName = JSON.parse(userDetails).user.branch;
  const zone = JSON.parse(userDetails).user.zone;

  const dispatch = useDispatch();
  const slipRef = useRef(null);

  useEffect(() => {
    applyDateRange(null, null);
  }, []);

  const applyDateRange = async (startDate, endDate) => {
    const fromDate = convertDateInFormat(startDate, "DD-MM-YYYY")
      ? convertDateInFormat(startDate, "DD-MM-YYYY")
      : "";
    const toDate = convertDateInFormat(endDate, "DD-MM-YYYY")
      ? convertDateInFormat(endDate, "DD-MM-YYYY")
      : "";
    const resp = await dispatch(
      getDateRangeData(branchName, fromDate, toDate, userId, zone)
    );
    if (resp && resp.body) {
      setDateRangeData(resp.body);
      setShowPdf(true);
    }
  };

  const handlePdfDownload = async () => {
    try {
      setIsGenerating(true);
      await generatePdf(slipRef.current, "Deposit-Slip.pdf");
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <>
      <div className="cibil_comp">
        <div className="date-range">
          <DateRange applyDateRange={applyDateRange} />
        </div>
      </div>
      {showPdf && (
        <>
          {/* PDF BUTTON */}
          {daterangeData && daterangeData.length > 0 && (
            
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginBottom: "12px",
            }}
          >
            <button
              onClick={handlePdfDownload}
              disabled={isGenerating}
              style={{
                width: "200px",
                opacity: isGenerating ? 0.6 : 1,
                cursor: isGenerating ? "not-allowed" : "pointer",
              }}
            >
              {isGenerating ? "Generating PDF..." : "Download PDF"}
            </button>
          </div>
          )}

          <div ref={slipRef} className="pdf-wrapper">
            <div className="pdf-header-row">
              <div className="pdf-only-logo">
                <img src={logo} className="pdf-logo" style={{marginLeft: '30px'}} />
              </div>
            </div>

            {daterangeData && daterangeData.length > 0 && (
              <DepositSlipComponent data={daterangeData} />
            )}

            <div className="pdf-only-disclaimer">
              This is a system generated deposit slip report.
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default DepositeSlip;
